import { Container, Nav, Tab } from "react-bootstrap";
import React, { useState, useEffect, useReducer } from "react";
import { useTranslation } from 'react-i18next';
import PageTitle from '../pageTitle/template_01';
import VIPContainer from '../../dynamic_section/dynamic_2/template_01';
import { Link, NavLink, useNavigate, useLocation } from "react-router-dom";
import { useMediaQuery } from 'react-responsive';
import SECTION_COMMISSIONPLAN from
'../../dynamic_section/dynamic_2/template_01';

import "./template_01.css";


const CommissionPlan = (props) => {
  const { t } = useTranslation();
  const {desktopBannerToggle, mobileBannerToggle } = props;

  const isDesktopOrLaptop = useMediaQuery({
    query: '(min-width: 992px)'
  })

  // useEffect(() => {
  //   const getCurrentTab = vipState.defaultVipTabs.find(tab => tabProps[tab.toggle]);
  //   if (getCurrentTab) {
  //     vipDispatch({ type: VIP_ACTION.SET_VIP_TABS, payload: getCurrentTab });
  //   }
  // }, [vipState.defaultVipTabs, tabProps]);

  // function getCurrentTab(tabProps) {
  //   for (let i = 0; i < vipState.defaultVipTabs.length; i++) {
  //     if (tabProps[vipState.defaultVipTabs[i].toggle]) {
  //       return vipState.defaultVipTabs[i].code;
  //     }
  //   }
  //   return null;  
  // }
  // vipDispatch({ type: VIP_ACTION.SET_VIP_TABS, payload: getCurrentTab(tabProps) })



    return (
      <section id="commissionPlan_01">
        <div className="commissionPlan_body">
          <PageTitle desktopToggle={false} mobileToggle={true} title={`commission_plan`} id={'commissionPlan_title'} />
            
  < SECTION_COMMISSIONPLAN desktopToggle={ true }
    mobileToggle={ false } label={ `Dynamic Section2` } id={ `commissionPlan` } supportLanguage={
    false } titleToggle={ false } titleIconToggle={
    true } linkTo={ `` } addContainer={ true } />
  
  
  
  

  
  < SECTION_COMMISSIONPLAN desktopToggle={ false }
    mobileToggle={ true } label={ `Dynamic Section2` } id={ `commissionPlan_m` } supportLanguage={
    false } titleToggle={ false } titleIconToggle={
    true } linkTo={ `` } addContainer={ false } />
  
        </div>
      </section>
    );
 
}

export default CommissionPlan;
